import { ChatMessageItem, JdDataAiResponseResult } from "@src/api";
import { ClientCompanyData, ExpertProfile } from "@src/api/types";
import { DefaultValue, atom, selector } from "recoil";
import { v1, v4 } from "uuid";
import { UserInfo } from "../types/userInfo";

const initState = atom({
	key: `initState${v1()}`,
	default: false,
});

const initPage = atom({
	key: `initPage${v1()}`,
	default: "",
});

// local 로그인상태 테스트시 해당 설정을 변경하여 테스트 가능하다.
const userState = atom({
	key: `userState${v1()}`,
	default: {
		isLogin: false,
		userId: "",
		userName: "",
		userType: 0,
		channelTalkId: null,
		userPhone: "",
		userRoute: "",
		userRouteDetail: "",
		userNickname: "",
		position: "",
		introDate: "",
		userLevel: 0,
		userUuid: "",
		refCode: "",
	},
});

const companyState = atom({
	key: `companyState${v1()}`,
	default: {
		companyName: "",
		companySize: "",
	},
});

const hasProfileData = atom({
	key: `hasProfileData${v1()}`,
	default: false,
});

const clientCompanyInfo = atom<ClientCompanyData>({
	key: `clientCompanyInfo${v1()}`,
	default: {
		brandUrl: "",
		brandName: "",
		companyIndustry: "",
		companyName: "",
		companySize: "",
		companyType: "",
		roundOfInvestment: "",
	},
});

const clientCompanyInfoSelector = selector({
	key: `clientCompanyInfoSelector${v1()}`,
	get: ({ get }) => get(clientCompanyInfo),
	set: ({ set, get }, value) => {
		set(clientCompanyInfo, value);
	},
});

const expertProfile = atom<ExpertProfile>({
	key: `expertProfile${v1()}`,
	default: {
		stage: "",
		stageId: null,
		stageDetail: null,
		uuid: "",
	},
});

const expertProfileSelector = selector({
	key: `expertProfileSelector${v1()}`,
	get: ({ get }) => get(expertProfile),
	set: ({ set, get }, value) => {
		set(expertProfile, value);
	},
});

const hasProfileDataSelector = selector({
	key: `hasProfileDataSelector${v1()}`,
	get: ({ get }) => get(hasProfileData),
	set: ({ set, get }, value) => {
		set(hasProfileData, value);
	},
});

const globalSnackbarState = atom({
	key: `globalSnackbarState${v1()}`,
	default: "",
});

const globalDialogState = atom({
	key: `globalDialogState${v1()}`,
	default: {
		open: false,
		title: "",
		desc: "",
		btn1Text: "",
		btn2Text: "",
		onClickBtn1: () => {
			//
		},
		onClickBtn2: () => {
			//
		},
		color: "black",
		backgroundColor: "white",
		type: "check",
		message: "",
		listItems: [] as string[],
		noCancelBtn: false,
		size: "sm" as "sm" | "md" | "lg" | "xl" | "xs",
	},
});

const globalDialogStateSelector = selector({
	key: `globalDialogStateSelector${v1()}`,
	get: ({ get }) => get(globalDialogState),
	set: ({ set, reset }, newValue) => {
		if (newValue instanceof DefaultValue) {
			reset(globalDialogState);
		} else {
			set(globalDialogState, newValue);
		}
	},
});

const globalLoadingSnackbarState = atom({
	key: `globalLoadingSnackbarState${v1()}`,
	default: "",
});

const globalLoadingSnackbarStateSelector = selector({
	key: `globalLoadingSnackbarStateSelector${v1()}`,
	get: ({ get }) => get(globalLoadingSnackbarState),
	set: ({ set, get }, value) => {
		set(globalLoadingSnackbarState, value);
	},
});

const globalLoadingState = atom({
	key: `globalLoadingState${v1()}`,
	default: false,
});

const globalLoadingStack = atom({
	key: `globalLoadingStack${v1()}`,
	default: 0,
});

const globalLoadingStackSelector = selector({
	key: `globalLoadingStackSelector${v1()}`,
	get: ({ get }) => get(globalLoadingStack),
	set: ({ set, get }, value) => {
		const count = get(globalLoadingStack);
		const result = count + (value as number);
		set(globalLoadingStack, result);
	},
});

const getUserDataHook = atom({
	key: `getUserDataHook${v1()}`,
	default: "0",
});

export const selectId = atom({
	key: `selectId${v1()}`,
	default: 1,
});

export {
	clientCompanyInfoSelector,
	companyState,
	expertProfileSelector,
	getUserDataHook,
	globalDialogState,
	globalDialogStateSelector,
	globalLoadingSnackbarStateSelector,
	globalLoadingStack,
	globalLoadingStackSelector,
	globalLoadingState,
	globalSnackbarState,
	hasProfileData,
	hasProfileDataSelector,
	initPage,
	initState,
	userState,
};

export const isApplyOpenAtom = atom({
	key: `isApplyOpen${v1()}`,
	default: false,
});

export const isChatOpenAtom = atom({
	key: `isChatOpen${v1()}`,
	default: false,
});

export const userInfoAtom = atom<UserInfo>({
	key: `userInfo${v1()}`,
	default: {
		name: "",
		phone: "",
		email: "",
		companyName: "",
		industry: "",
		companySize: "",
		position: "",
		route: "",
		routeDetail: "",
		inviteCode: "",
	},
});

export const messagesAtom = atom({
	key: `messages${v1()}`,
	default: [] as ChatMessageItem[],
});

export const aiMatchUuidAtom = atom({
	key: `aiMatchUuid${v1()}`,
	default: v4(),
});

export const aiConsultResultDataAtom = atom({
	key: `aiConsultResultData${v1()}`,
	default: null as JdDataAiResponseResult | null,
});

export const defaultMessageAtom = atom({
	key: `defaultMessage${v1()}`,
	default: "",
});
